<script setup lang="ts">
import { NavigationLinkTabs } from '@shared/ui/menus'

import { useCustomerDetailMenu } from '../model/customer-detail-menu.hook'

defineOptions({
  name: 'CustomerDetailMenu',
})

const {
  menuRef,
  config,
} = useCustomerDetailMenu()
</script>

<template>
  <div
    ref="menuRef"
    class="customer-detail-menu"
  >
    <NavigationLinkTabs
      :config="config"
    />
  </div>
</template>

<style scoped lang="scss" src="./CustomerDetailMenu.scss" />
